import { render } from "./ModalCaricaExcel.vue?vue&type=template&id=10032a80&ts=true"
import script from "./ModalCaricaExcel.vue?vue&type=script&lang=ts"
export * from "./ModalCaricaExcel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__